/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */

/** @module core/modules/object-utils/has-keys */
import { getLength } from './get-length.js';
/**
 * @description Returns true if the input has obtainable keys and false otherwise.
 * @param {*} input - Input value.
 * @returns {boolean} Result.
 */

function hasKeys(input) {
  return getLength(input) > 0;
}

export { hasKeys };